import styled from 'styled-components';
export const Wrapper = styled.div ``;
export const ButtonWrapper = styled.div `
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 2rem;
  
  .btn {
    width: 50%;  
  }
`;
export const Title = styled.span `
  display: block;
`;
export const Copy = styled.span `
  display: block;
  margin-top: 1rem;
`;
export default {
    Wrapper,
};
